import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function todayInputValue() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

export const OverdueRecurrenceDialog = ({ open, suggestedDue, busy, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(suggestedDue || "");

  useEffect(() => {
    if (open) setValue((suggestedDue || "").slice(0, 10));
  }, [open, suggestedDue]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-end justify-center bg-slate-900/40 p-4 sm:items-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="overdue-next-due-title"
    >
      <form
        className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl"
        onSubmit={(event) => {
          event.preventDefault();
          if (value) onConfirm(value);
        }}
      >
        <h2 id="overdue-next-due-title" className="text-lg font-bold text-slate-900">
          {t("todo.nextDueTitle")}
        </h2>
        <p className="mt-2 text-sm leading-6 text-slate-600">{t("todo.nextDueHint")}</p>
        <label className="mt-4 block text-sm font-semibold text-slate-800">
          {t("todo.nextDueLabel")}
          <input
            type="date"
            required
            min={todayInputValue()}
            value={value}
            onChange={(event) => setValue(event.target.value)}
            className="mt-1 min-h-[44px] w-full rounded-xl border border-slate-200 px-3 text-sm"
          />
        </label>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            className="min-h-[44px] rounded-xl border border-slate-200 px-4 text-sm font-semibold text-slate-700"
            onClick={onCancel}
            disabled={busy}
          >
            {t("common.cancel")}
          </button>
          <button
            type="submit"
            className="min-h-[44px] rounded-xl bg-[#1463C7] px-4 text-sm font-semibold text-white disabled:opacity-50"
            disabled={busy || !value}
          >
            {t("todo.nextDueConfirm")}
          </button>
        </div>
      </form>
    </div>
  );
};
